import React, { Component } from 'react'

import Header from '../Header'
import SlickCarousel, { SlickItem } from '../../../../third-party/SlickCarousel'

import ImageLightBox from '../../../../third-party/ImageLightBox'

import style from './style.css'
import global from '../style.css'
export default class Boxtext extends Component {

    state = {
        images: null,
        lightBox: false,
        indexImageLightBox: 0
    }


    openImage(index) {
        this.setState({
            indexImageLightBox: index,
            lightBox: true,
        })
    }

    componentDidMount() {
        let images = [];

        for (let i = 0; i < this.props.data.files.length; i++) {
            const element = this.props.data.files[i];
            images.push(element.url)
        }
        
        this.setState({
            images
        })
    }

    render() {
        let data = this.props.data
        return(
            <div className={`${global.box} ${ this.props.needApprove ? global.needApprove : '' }`}>
                <Header
                    is_admin={this.props.is_admin}
                    data={data}
                    needApprove={this.props.needApprove}
                    actionDelete={(id) => this.props.handleDelete(id) }
                    onApprove={() => this.props.onApprove()}/>
                
                <div
                className={style.content}>
                
                    {data.files.length === 1 && (
                        <a onClick={() => { this.openImage(0) }} style={{ cursor: 'pointer', float: 'left', width: '100%' }}>
                            <div className={style.images}>
                                <img src={`${data.files[0].url}`} alt={data.files[0].original_name} />
                            </div>
                        </a>
                    )}

                    {data.files.length > 1 && (
                        <SlickCarousel draggable arrows={false} itens={1} centerMode>
                            { data.files.map( (image, key) => (
                                <SlickItem key={image.file} onClick={() => { this.openImage(key) }} style={{ cursor: 'pointer' }}>
                                    <div className={style.images}>
                                        <img src={`${image.url}`} alt={image.original_name} />
                                    </div>
                                </SlickItem>
                            )) }
                        </SlickCarousel>
                    )}

                    {data.content}
                </div>
                {this.props.children}
                <ImageLightBox handleClose={() => {
                            this.setState({
                                lightBox: false
                            })
                        }} isOpen={this.state.lightBox} images={this.state.images} photoIndex={this.state.indexImageLightBox}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Timeline/Containers/BoxImage/index.js